export const BASE = "base";
export * from "../../../_constants/SocialProvider";
